import { render, staticRenderFns } from "./TagesSaldenAntrag.vue?vue&type=template&id=c459c804&scoped=true"
import script from "./TagesSaldenAntrag.vue?vue&type=script&lang=ts"
export * from "./TagesSaldenAntrag.vue?vue&type=script&lang=ts"
import style0 from "./TagesSaldenAntrag.vue?vue&type=style&index=0&id=c459c804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c459c804",
  null
  
)

export default component.exports